
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/airports/toplists/[id]",
      function () {
        return require("private-next-pages/airports/toplists/[id].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/airports/toplists/[id]"])
      });
    }
  